import * as React from "react";
import type { SVGProps } from "react";
const SvgWeChat = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={140}
    height={140}
    fill="none"
    {...props}
  >
    <circle cx={60} cy={60} r={60} fill="url(#we-chat_svg__a)" />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M100 69.328C100 58.092 89.254 49 76 49c-13.255 0-24 9.092-24 20.328 0 11.195 10.745 20.286 24 20.327a29.4 29.4 0 0 0 7.873-1.173c.183-.05.168-.048.65-.145.484-.096.904.145 1.269.34l5.184 3.128c.238.13.38.195.576.195a.78.78 0 0 0 .768-.781c.009-.231-.064-.415-.12-.61-.056-.192-.7-2.576-1.032-4.081-.047-.214-.074-.336-.074-.74s.205-.837.65-1.215c5.022-3.64 8.256-9.148 8.256-15.245m-32.158-3.519c-1.603 0-2.979-1.4-2.979-3.221 0-1.633 1.376-3.034 2.979-3.034 1.79 0 3.165 1.401 3.165 3.033 0 1.823-1.375 3.222-3.165 3.222m15.935 0c-1.602 0-2.978-1.4-2.978-3.221 0-1.633 1.376-3.034 2.978-3.034 1.791 0 3.166 1.401 3.166 3.033 0 1.823-1.375 3.222-3.166 3.222"
      clipRule="evenodd"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M20 51.148c0 7.196 3.863 13.728 9.947 18.158.448.334.687.715.687 1.354 0 .222-.038.46-.114.772-.509 2.102-1.067 4.507-1.148 4.83-.08.321-.207.535-.19.772a.94.94 0 0 0 .956.966c.19 0 .36-.078.573-.194l6.312-3.67c.4-.244.849-.37 1.15-.37.304 0 .81.095 1.146.177 2.926.755 6.085 1.228 9.372 1.159a6.3 6.3 0 0 0 1.53 0 20 20 0 0 1-.956-5.795C49.289 57.1 60.998 47.264 75.47 47.284c.496-.02 1.013-.004 1.53 0C74.84 35.8 62.983 27 48.691 27 32.839 27 20 37.785 20 51.148m18.936-3.864a3.8 3.8 0 0 1-2.705-1.131 3.896 3.896 0 0 1 0-5.464 3.794 3.794 0 0 1 5.41 0 3.87 3.87 0 0 1 1.12 2.732 3.9 3.9 0 0 1-1.12 2.732 3.794 3.794 0 0 1-2.705 1.132m19.128 0a3.8 3.8 0 0 1-2.705-1.131 3.87 3.87 0 0 1-1.12-2.732 3.9 3.9 0 0 1 1.12-2.732 3.794 3.794 0 0 1 2.705-1.132 3.8 3.8 0 0 1 2.67 1.151 3.88 3.88 0 0 1 1.1 2.713c0 1.015-.396 1.989-1.1 2.712a3.8 3.8 0 0 1-2.67 1.151"
      clipRule="evenodd"
    />
    <defs>
      <linearGradient
        id="we-chat_svg__a"
        x1={60.001}
        x2={60.001}
        y1={0.326}
        y2={120.002}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#02E36F" />
        <stop offset={1} stopColor="#07C160" />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgWeChat;
